import { GetTotalItemRequest, PriceRange, Catalog } from '../models/keyword_detail_condition_env';

export class KeywordDetailCondition {
  getSelectCondition(): GetTotalItemRequest {
    const iconConditionArray: string[] = Array.prototype.slice
      .call(document.getElementsByName('itemIcon'))
      .filter((checkbox) => checkbox.checked)
      .map((item) => item.value);
    const searchWord: string | null =
      (document.getElementById('searchword') as HTMLInputElement)?.value || null;
    const exclusionWord: string | null =
      (document.getElementById('excludeword') as HTMLInputElement)?.value || null;
    const shouldSearchScopeControl: boolean = (document.getElementById(
      'searchWordConditions'
    ) as HTMLInputElement).checked;
    const isFromSameToTwoDay: boolean = (document.getElementById('delivery-01') as HTMLInputElement)
      .checked;
    const isDeliveryEstimate: boolean = (document.getElementById('delivery-02') as HTMLInputElement)
      .checked;
    const shouldExcludeLargeSizeItem: boolean = (document.getElementById(
      'delivery-03'
    ) as HTMLInputElement).checked;
    const minPrice: string | null =
      (document.getElementById('price-01') as HTMLInputElement)?.value || null;
    const maxPrice: string | null =
      (document.getElementById('price-02') as HTMLInputElement)?.value || null;
    const supplierId: string | null =
      (document.getElementById('supplierId') as HTMLInputElement)?.value || null;
    const catalogCode: string | null =
      (document.getElementById('catalogCode') as HTMLInputElement)?.value || null;

    let priceRange: PriceRange | null;
    if (minPrice != null || maxPrice != null) {
      priceRange = new PriceRange(minPrice, maxPrice);
    } else {
      priceRange = null;
    }

    let catalog: Catalog | null;
    if (supplierId != null && catalogCode != null) {
      catalog = new Catalog(supplierId, catalogCode);
    } else {
      catalog = null;
    }

    const isCbItem: boolean =
    (document.getElementsByName('isCbItem')[0] as HTMLInputElement)?.checked || false;

    return new GetTotalItemRequest(
      searchWord,
      exclusionWord,
      shouldSearchScopeControl,
      iconConditionArray,
      isFromSameToTwoDay,
      shouldExcludeLargeSizeItem,
      isDeliveryEstimate,
      priceRange,
      catalog,
      isCbItem
    );
  }

  hasAnyCondition(getTotalItemRequest: GetTotalItemRequest): boolean {
    return (
      getTotalItemRequest.keyword === null &&
      getTotalItemRequest.exclusionWord === null &&
      getTotalItemRequest.itemIconCodeList.length === 0 &&
      getTotalItemRequest.isFromSameToTwoDay === false &&
      getTotalItemRequest.shouldExcludeLargeSizeItem === false &&
      getTotalItemRequest.isDeliveryEstimate === false &&
      getTotalItemRequest.priceRange === null &&
      getTotalItemRequest.catalog === null &&
      getTotalItemRequest.isCbItem === false
    );
  }

  createTotalItemParameter(model: GetTotalItemRequest):string {
    const parameterKeyValueList: { [key: string]: string } = {};

    parameterKeyValueList.isTotalCountView = 'true'

    if (model.keyword !== null) {
      parameterKeyValueList.searchWord = model.keyword;
    }

    if (model.exclusionWord !== null) {
      parameterKeyValueList.exclusionWord = model.exclusionWord;
    }

    if (model.shouldSearchScopeControl !== false) {
      parameterKeyValueList.searchControlKbn = '1';
    }

    if (model.itemIconCodeList.length > 0) {
      parameterKeyValueList.itemIcon = model.itemIconCodeList.join(',');
    }

    if (model.shouldExcludeLargeSizeItem !== false) {
      parameterKeyValueList.spcialDelivPicExclusionFlg = '1';
    }

    if (model.isDeliveryEstimate !== false) {
      parameterKeyValueList.exclusionFlg = '1';
    }

    if (model.isFromSameToTwoDay !== false) {
      parameterKeyValueList.deliveryEstimate = '1';
    }

    if (model.priceRange !== null) {
      if (model.priceRange?.minPrice !== null) {
        parameterKeyValueList.minPriceRange = model.priceRange?.minPrice;
      }

      if (model.priceRange?.maxPrice !== null) {
        parameterKeyValueList.maxPriceRange = model.priceRange?.maxPrice;
      }
    }

    if (model.catalog !== null) {
      parameterKeyValueList.supplierId = model.catalog.supplierId;
      parameterKeyValueList.catalogCode = model.catalog.catalogCode;
    }

    if (model.isCbItem !== false) {
      parameterKeyValueList.isCbItem = '1';
    }

    return new URLSearchParams(parameterKeyValueList).toString();
  }
}
